export const CHECK_CONTACT_DUPLICATE_START = 'CHECK_CONTACT_DUPLICATE_START';

export const CHECK_CONTACT_DUPLICATE_SUCCESS = 'CHECK_CONTACT_DUPLICATE_SUCCESS';

export const CHECK_CONTACT_DUPLICATE_FAILURE = 'CHECK_CONTACT_DUPLICATE_FAILURE';
